import { ApplicationConstants } from './applicationConstants';

export class ApplicationConfig {
    static galleryElementsPerPage = 20;
    static minCharsToFilterText = 3;
    static defaultSortOrder = ApplicationConstants.descendingOrder;
}



// WEBPACK FOOTER //
// ./src/shared/applicationConfig.js